class AccountingSftpSie4Controller extends AbstractSftpController
	@register()
	@inject 'translate',
		'IntegrationService',
		'Shops',
		'ShopRepository',
		'VatRates',
		'TenderTypes',
		'BACKEND_TRANSACTION_CARD_TYPE'

	integrationId: 'accountingSftpSie4'

	initialize: ->
		super()

		@$scope.maxAccountLength = 4

		@ensureObjectsInConfiguration(@$scope.configuration, ['cost_centers', 'deviation', 'downpayment'])

		@$scope.paymentAccounts = @IntegrationService.getMappableSftpAccounts()
		@$scope.cardTypes = @BACKEND_TRANSACTION_CARD_TYPE

		@defaultEntitiesDataList = [{id: 'unspecified', name: 'unspecified'}]

		@$scope.tenderTypes = @TenderTypes.data.concat(@defaultEntitiesDataList)
		@tenderTypeMap = _.indexBy(@$scope.tenderTypes, 'id')

		@$scope.vatRates = _.map(@VatRates.data.concat(@defaultEntitiesDataList), (vatRate) =>
			if (vatRate.percentage)
				vatRate.name = vatRate.name + ' (' + (vatRate.percentage * 100).toFixed(2) + ' %)'
			return vatRate
		)
		@vatRateMap = _.indexBy(@$scope.vatRates, 'id')

		@$scope.shops = _.map(@Shops.data.concat(@defaultEntitiesDataList), (shop) =>
			shop.name = shop.name + (if shop.address then ' / ' + shop.address else '')
			return shop
		)
		@shopMap = _.indexBy(@$scope.shops, 'id')

	save: ->
		@$scope.configuration.payments = @preparePayments()
		@$scope.configuration.card_types = @prepareCardTypes()
		@$scope.configuration.vat_rates = @prepareVatRates()
		@$scope.configuration.vat_rates_revenue = @prepareVatRatesRevenue()
		@$scope.configuration.tender_types = @prepareTenderTypes()
		@$scope.configuration.shops = @prepareShops()
		@$scope.configuration.deviation = @prepareDeviation()
		@$scope.configuration.downpayment = @prepareDownpayment()

		super()

	prepareDeviation: ->
		return {} if !@$scope.configuration.deviation.account

		return {
			account: @$scope.configuration.deviation.account
			name: @translate('wbo.integration.accountingSftpSie4.deviation.heading')
		}

	prepareDownpayment: ->
		return {} if !@$scope.configuration.downpayment.account

		return {
			account: @$scope.configuration.downpayment.account
			name: @translate('pdf.report.sales.downpayments')
		}

	prepareShops: ->
		return @prepareConfigurations(
			@$scope.configuration.shops,
			(id) => @shopMap[id].name,
			(id) => @shopMap[id]?
			'number'
		)

	prepareTenderTypes: ->
		return @prepareConfigurations(
			@$scope.configuration.tender_types,
			(id) => @tenderTypeMap[id].name
			(id) => @tenderTypeMap[id]?
		)

	prepareVatRates: ->
		return @prepareConfigurations(
			@$scope.configuration.vat_rates,
			(id) => @vatRateMap[id].name
			(id) => @vatRateMap[id]?
		)

	prepareVatRatesRevenue: ->
		return @prepareConfigurations(
			@$scope.configuration.vat_rates_revenue,
			(id) => @vatRateMap[id].name
			(id) => @vatRateMap[id]?
		)

	preparePayments: ->
		return @prepareConfigurations(
			@$scope.configuration.payments,
			(id) => _.find(@$scope.paymentAccounts, (payment) => payment.key == id).title
		)

	prepareCardTypes: ->
		return @prepareConfigurations(@$scope.configuration.card_types)

	prepareConfigurations: (
		configurations,
		nameResolver = null,
		canSetConfigurationResolver = null,
		enteredDataField = 'account',
	) ->
		prepared = {}

		for id, configuration of configurations
			canSetConfiguration = if canSetConfigurationResolver? then canSetConfigurationResolver(id) else true

			if !configuration[enteredDataField] || !canSetConfiguration
				continue

			configuration.name = @translate(if nameResolver then nameResolver(id) else id)
			prepared[id] = configuration

		return prepared

	runIntegration: (timestampFrom, timestampTo, timeZone, splitByDays) ->
		@$scope.saving = true

		requestBody =
			from: timestampFrom
			to: timestampTo
			time_zone: timeZone
			split_by_days: splitByDays

		@IntegrationRepository
			.run(@integrationId, requestBody)
			.then =>
				@ToastService.add(
					@translate(@headerText),
					@translate('general.integration'),
					@translate('general.operation.success'),
					'success'
				)
			.catch (response) =>
				@ToastService.showErrors response, @translate(@headerText)
			.finally =>
				@$scope.saving = false

	afterDisconnect: ->
		@$scope.configuration = {}
